// src/components/layout/NavLink.tsx
"use client";

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { cn } from '@/lib/utils'; // Assuming cn utility for classnames
import React from 'react';

type NavLinkVariant = 'default' | 'brandPink';

interface NavLinkProps extends React.ComponentPropsWithoutRef<typeof Link> {
  isActive: boolean;
  children: React.ReactNode;
  variant?: NavLinkVariant;
}

export function NavLink({ href, isActive, children, className, variant = 'default', ...props }: NavLinkProps) {
  const pathname = usePathname();
  const isActiveLink = pathname === href || isActive; // Use isActive prop or compare with current pathname

  const variantClasses = (() => {
    if (variant === 'brandPink') {
      return {
        base: 'text-[#D1007A]',
        active: 'text-[#A5005D]',
        hover: 'hover:text-[#A5005D]',
      };
    }
    return {
      base: 'text-muted-foreground',
      active: 'text-primary',
      hover: 'hover:text-primary',
    };
  })();

  return (
    <Link
      href={href}
      className={cn(
        'transition-colors',
        variantClasses.hover,
        isActiveLink ? variantClasses.active : variantClasses.base,
        className
      )}
      {...props}
    >
      {children}
    </Link>
  );
}
